import * as React from 'react';

function prefixdomain(path: string) {
  if (typeof path !== 'string') {
    console.log(`img.resize expect img path of string, but got ${typeof path}`);
    return path;
  }

  if (/^(https?:)?\/?\/.*/.test(path)) {
    return path;
  }

  return '//img30.360buyimg.com/pop/' + path;
}

function resize(path: string, w: number = 100, h: number = w, useDpg: boolean = false): string {
  if (typeof path !== 'string') {
    console.log(`img.resize expect img path of string, but got ${typeof path}`);
    return path;
  } else if (!path.includes('.360buyimg.com') || typeof w !== 'number' || typeof h !== 'number') {
    return path;
  }
  path = path.replace(/(jfs)|(s\d+x\d+_jfs)/, function () {
    return `s${w}x${h}_jfs`;
  });
  if (useDpg) {
    path = path + '.dpg';
  }
  return path;
}

interface Props {
  src: any;
  width?: any;
  height?: any;
  dpg?: any;
  className?: string;
  onError?: any;
}

function JDImage({ src = '', width = 100, height = width, dpg, onError, ...options }: Props, ref: any): JSX.Element {
  src = resize(prefixdomain(src), width, height, dpg);
  return (
    <img style={{ width: width + 'px', height: height + 'px' }} ref={ref} src={src} {...options} onError={onError} />
  );
}

export default React.memo(React.forwardRef(JDImage));
